import { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { languages } from "../../utils/global_const";

const Mask = styled.div`
  margin-top: var(--spacing-xxs);
  background-color: transparent;
  position: fixed;
  right: 0;
  top: 0;
  z-index: var(--zindex-default);
  min-width: 100%;
  height: 100vh;

  box-sizing: border-box;
`;
const ItemContainer = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  width: auto;

  background-color: var(--bg-200);
  border-radius: var(--border-radius-large);
  padding: 6px 10px;
  transition: background-color 0.15s ease-in-out;

  font-size: var(--font-size-small);
  font-weight: 600;

  &:hover,
  &:focus-visible {
    background-color: var(--bg-300);
  }
`;
const Span = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: var(--font-size-small);
  color: var(--text-100);
`;
const Picture = styled.picture`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const SVGArrow = styled.svg`
  flex-shrink: 0;
`;

const RadioContainer = styled.div`
  position: absolute;
  top: calc(100% + var(--spacing-xs));
  left: 0;
  right: auto;
  z-index: 1;

  display: flex;
  flex-direction: column;

  width: auto;
  min-width: 160px;
  max-width: calc(100vw - var(--spacing-xl));
  background-color: var(--bg-100);
  border-radius: var(--border-radius-base);
  box-shadow: var(--shadow-large);
  padding: 4px;
`;
const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);

  cursor: pointer;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--border-radius-small);
  font-size: var(--font-size-small);
  color: var(--text-100);
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: var(--bg-200);
  }
`;

const Language = () => {
  const { i18n } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const [currentLang, setCurrentLang] = useState(
    languages.find(
      (lang) => lang.code.toLowerCase() === i18n.language.toLowerCase()
    ) || languages[0]
  );

  useEffect(() => {
    // Ažurirajte currentLang svaki put kada se promeni i18n.language
    const foundLang = languages.find(
      (lang) => lang.code.toLowerCase() === i18n.language.toLowerCase()
    );
    setCurrentLang(foundLang || languages[0]); // Postavite na pronađeni jezik ili na podrazumevani jezik ako pronađeni jezik ne postoji
  }, [i18n.language]);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang.code);
    setCurrentLang(lang);
    setShowMenu(false);

    const currentUrl = window.location.pathname;
    const urlSegments = currentUrl.split("/").filter((segment) => segment);

    // Izbacujemo prethodni lang kod ako postoji
    const newUrlSegments = urlSegments.filter(
      (segment) =>
        !languages.some(
          (language) => language.code.toLowerCase() === segment.toLowerCase()
        )
    );

    // Dodajemo novi lang kod
    newUrlSegments.unshift(lang.code.toLowerCase());

    // Kreiramo novi URL
    const newUrl = `/${newUrlSegments.join("/")}`;

    // Menjamo URL bez učitavanja stranice
    window.history.pushState({}, "", newUrl);
  };

  return (
    <>
      {currentLang && (
        <>
          {showMenu && <Mask onClick={toggleMenu} />}
          <ItemContainer
            onClick={toggleMenu}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleMenu();
              }
            }}
          >
            <Span>
              <Picture>
                <Image
                  src={currentLang.flag}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                />
              </Picture>
              {currentLang.code.toUpperCase()}
            </Span>
            <SVGArrow
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={showMenu ? { transform: "rotate(180deg)" } : {}}
            >
              <path
                d="M-0.000325203 0.333496L4.66634 5.66683L9.33301 0.333496L-0.000325203 0.333496Z"
                fill="var(--text-200)"
              />
            </SVGArrow>

            {showMenu && (
              <RadioContainer>
                {languages.map((lang) => (
                  <StyledLabel
                    key={lang.code}
                    onClick={() => handleLanguageChange(lang)}
                  >
                    <Picture>
                      <Image src={lang.flag} alt="" aria-hidden="true" />
                    </Picture>
                    {lang.label}
                  </StyledLabel>
                ))}
              </RadioContainer>
            )}
          </ItemContainer>
        </>
      )}
    </>
  );
};

export default Language;
